import React from 'react'
import Videosection from '../Menhome/Videosection'
import Special from '../Menhome/Special'
import Contact from '../Menhome/Contact'
import Banner from '../Menhome/Banner'
import Offer from '../Menhome/Offer'
import Story from '../Menhome/Story'
import Specialdish from '../Menhome/Specialdish'
import Menusection from '../Menhome/Menusection'
import Whyus from '../Menhome/Whyus'
import Teem from '../Menhome/Teem'
import Reacntupdate from '../Menhome/Recntupdates'
import { Link } from 'react-router-dom'
import sidebarlogo from '../../assets/images/resource/sidebar-logo.png'
import Feature from '../Menhome/Feature'


function Main() {
    return (
        <>
            <div className="menu-backdrop"> </div>

            <section className="hidden-bar">
                <div className="inner-box">
                    <div className="cross-icon hidden-bar-closer"><span className="far fa-close"></span></div>
                    <div className="logo-box"><Link to="/" title="BonAppetit"><img src={sidebarlogo} alt="" title="BonAppetit" /></Link></div>

                    <div className="side-menu">
                        <ul className="navigation clearfix">
                            <li className="current"><Link to="/">Početna</Link></li>
                            <li><Link to="/menu">Meni</Link></li>
                            <li><Link to="/about">O nama</Link></li>
                            <li><Link to="/contact">Kontakt</Link></li>
                        </ul>
                    </div>

                    <h2>Posetite nas</h2>
                    <ul className="info">
                        <li>Ivana Gundulića 7, <br /> Smederevo 230437</li>
                        <li>Radno vreme: 08:00 - 22:30</li>
                    </ul>
                    <div className="separator"><span></span></div>
                    <div className="booking-info">
                        <div className="bk-title">Poručite na broj</div>
                        <div className="bk-no"><Link to="tel:+381 64 1856 290">+381 64 1856 290</Link></div>
                    </div>
                </div>
            </section>

            <Banner />
            <Offer />
            <Story />
            <Specialdish />
            <Menusection />
            <Special />
            <Contact />
            <Whyus />
            <Feature />
            <Teem />
            <Videosection />
            <Reacntupdate />
        </>
    )
}

export default Main